export const Enums = {
  MACLE_ERROR_LOG: 'MACLE_ERROR_LOG'
};
